import { createContext, useEffect, useState } from 'react'
import {
  getPageViewedInSession,
  setPageViewedInSession,
} from './PageViewProvider.helpers'
import { useRouter } from 'next/router'
import { useDebugger } from '../hooks'
import { navigationDirectionTracker } from '../../utils/navigationDirection'

interface IPageViewProvider {
  children: React.ReactNode
}

interface IPageViewContext {
  sessionPageView: number
  setSessionPageView: React.Dispatch<React.SetStateAction<number>>
}

const defaultState = {
  sessionPageView: 0,
  // eslint-disable-next-line @typescript-eslint/no-empty-function
  setSessionPageView: () => {},
} as IPageViewContext
export const PageViewContext = createContext(defaultState)
export const PageViewProvider = ({ children }: IPageViewProvider) => {
  const router = useRouter()
  const { setLog } = useDebugger()
  const [sessionPageView, setSessionPageView] = useState<number>(-1)

  useEffect(() => {
    // initPageViewedInSession()
    if (
      // eslint-disable-next-line
      // @ts-ignore
      window.performance.getEntriesByType('navigation')[0].type === 'reload' ||
      getPageViewedInSession() > 0
    ) {
      setSessionPageView(2)
    } else {
      setSessionPageView(1)
    }
  }, [])

  useEffect(() => {
    // Was `window.history.state?.idx` — Next 12 never sets an `idx` field
    // on history.state (confirmed against its router source), so that
    // always read as 0 and `isBack` was permanently true: sessionPageView
    // never actually incremented past its initial value on real forward
    // navigation. Shares the same tracker as NavigationProvider (safe to
    // call independently — resolving is idempotent per navigation key, see
    // navigationDirection.ts) instead of reading a field that never existed.
    const routeChangeComplete = () => {
      if (navigationDirectionTracker.handleRouteChangeComplete() === 'back') {
        return // לא מעלים pageView על back
      }

      setSessionPageView(prev => {
        setPageViewedInSession(prev + 1)
        return prev + 1
      })
    }

    router.events.on('routeChangeComplete', routeChangeComplete)

    return () => {
      router.events.off('routeChangeComplete', routeChangeComplete)
    }
  }, [router.events])

  useEffect(() => {
    setLog(prev => [...prev, `referrer : ${document.referrer}`])
    setLog(prev => [
      ...prev,
      `wasRefreshed : ${
        // eslint-disable-next-line
        // @ts-ignore
        window.performance.getEntriesByType('navigation')[0].type === 'reload'
      }`,
    ])
    setLog(prev => [...prev, `pv is: ${sessionPageView}`])
  }, [sessionPageView, setLog])

  return (
    <PageViewContext.Provider value={{ sessionPageView, setSessionPageView }}>
      {children}
    </PageViewContext.Provider>
  )
}
